import styled from 'styled-components';
import pencil from 'assets/img/icons/pencil.svg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: space-between;
`;

export const Title = styled.h4`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
`;

export const Card = styled.div`
  margin: 20px 0 40px 0;
  padding: 20px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100px;
  padding-right: 20px;
  border-right: 1px solid #e8e8e8;

  a{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: ${({ isAdmin }) => (isAdmin ? '#3E81F7' : '#565656')};
    margin-left: 8px;
    ${({ isAdmin }) => (isAdmin
    ? `
      :hover{
        text-decoration: underline;
      }`
    : `
      pointer-events: none;
      cursor: default;
  `)}
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;


export const CloseButton = styled.button`
  outline: none;
  border: none;
  background: rgba(248, 204, 164, 0.2);
  border-radius: 4px;
  height: 48px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  color: #F07E31;

  :hover{
    opacity: 0.6;
  }
`;

export const EditTag = styled.button`
  outline: none;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  padding-left: 25px;
  background: url(${pencil}) no-repeat left center;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;

  color: #F07E31;

  :hover{
    opacity: 0.6;
  }
`;

export const RowLabels = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: auto;
  flex-wrap: wrap;
  padding: 15px;
`;

export const LabelText = styled.h2`
  margin: 0;
  white-space: nowrap;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
  color: ${({ color }) => color};
`;
